import * as FirebaseAuth from './Authentication';
export const Auth = FirebaseAuth;

export default {
  ...Auth
};
